/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "เมื่อวาน",
        "-2": "เมื่อวานซืน",
        "0": "วันนี้",
        "1": "พรุ่งนี้",
        "2": "มะรืนนี้",
        "future": {
          "other": "ในอีก {0} วัน"
        },
        "past": {
          "other": "{0} วันที่ผ่านมา"
        }
      },
      "day-narrow": {
        "-1": "เมื่อวาน",
        "-2": "เมื่อวานซืน",
        "0": "วันนี้",
        "1": "พรุ่งนี้",
        "2": "มะรืนนี้",
        "future": {
          "other": "ใน {0} วัน"
        },
        "past": {
          "other": "{0} วันที่แล้ว"
        }
      },
      "day-short": {
        "-1": "เมื่อวาน",
        "-2": "เมื่อวานซืน",
        "0": "วันนี้",
        "1": "พรุ่งนี้",
        "2": "มะรืนนี้",
        "future": {
          "other": "ใน {0} วัน"
        },
        "past": {
          "other": "{0} วันที่แล้ว"
        }
      },
      "hour": {
        "0": "ชั่วโมงนี้",
        "future": {
          "other": "ในอีก {0} ชั่วโมง"
        },
        "past": {
          "other": "{0} ชั่วโมงที่ผ่านมา"
        }
      },
      "hour-narrow": {
        "0": "ชั่วโมงนี้",
        "future": {
          "other": "ใน {0} ชม."
        },
        "past": {
          "other": "{0} ชม. ที่แล้ว"
        }
      },
      "hour-short": {
        "0": "ชั่วโมงนี้",
        "future": {
          "other": "ใน {0} ชม."
        },
        "past": {
          "other": "{0} ชม. ที่แล้ว"
        }
      },
      "minute": {
        "0": "นาทีนี้",
        "future": {
          "other": "ในอีก {0} นาที"
        },
        "past": {
          "other": "{0} นาทีที่ผ่านมา"
        }
      },
      "minute-narrow": {
        "0": "นาทีนี้",
        "future": {
          "other": "ใน {0} นาที"
        },
        "past": {
          "other": "{0} นาทีที่แล้ว"
        }
      },
      "minute-short": {
        "0": "นาทีนี้",
        "future": {
          "other": "ใน {0} นาที"
        },
        "past": {
          "other": "{0} นาทีที่แล้ว"
        }
      },
      "month": {
        "-1": "เดือนที่แล้ว",
        "0": "เดือนนี้",
        "1": "เดือนหน้า",
        "future": {
          "other": "ในอีก {0} เดือน"
        },
        "past": {
          "other": "{0} เดือนที่ผ่านมา"
        }
      },
      "month-narrow": {
        "-1": "เดือนที่แล้ว",
        "0": "เดือนนี้",
        "1": "เดือนหน้า",
        "future": {
          "other": "ใน {0} เดือน"
        },
        "past": {
          "other": "{0} เดือนที่แล้ว"
        }
      },
      "month-short": {
        "-1": "เดือนที่แล้ว",
        "0": "เดือนนี้",
        "1": "เดือนหน้า",
        "future": {
          "other": "ใน {0} เดือน"
        },
        "past": {
          "other": "{0} เดือนที่แล้ว"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "ไตรมาสที่แล้ว",
        "0": "ไตรมาสนี้",
        "1": "ไตรมาสหน้า",
        "future": {
          "other": "ในอีก {0} ไตรมาส"
        },
        "past": {
          "other": "{0} ไตรมาสที่แล้ว"
        }
      },
      "quarter-narrow": {
        "-1": "ไตรมาสที่แล้ว",
        "0": "ไตรมาสนี้",
        "1": "ไตรมาสหน้า",
        "future": {
          "other": "ใน {0} ไตรมาส"
        },
        "past": {
          "other": "{0} ไตรมาสที่แล้ว"
        }
      },
      "quarter-short": {
        "-1": "ไตรมาสที่แล้ว",
        "0": "ไตรมาสนี้",
        "1": "ไตรมาสหน้า",
        "future": {
          "other": "ใน {0} ไตรมาส"
        },
        "past": {
          "other": "{0} ไตรมาสที่แล้ว"
        }
      },
      "second": {
        "0": "ขณะนี้",
        "future": {
          "other": "ในอีก {0} วินาที"
        },
        "past": {
          "other": "{0} วินาทีที่ผ่านมา"
        }
      },
      "second-narrow": {
        "0": "ขณะนี้",
        "future": {
          "other": "ใน {0} วินาที"
        },
        "past": {
          "other": "{0} วินาทีที่แล้ว"
        }
      },
      "second-short": {
        "0": "ขณะนี้",
        "future": {
          "other": "ใน {0} วินาที"
        },
        "past": {
          "other": "{0} วินาทีที่แล้ว"
        }
      },
      "week": {
        "-1": "สัปดาห์ที่แล้ว",
        "0": "สัปดาห์นี้",
        "1": "สัปดาห์หน้า",
        "future": {
          "other": "ในอีก {0} สัปดาห์"
        },
        "past": {
          "other": "{0} สัปดาห์ที่ผ่านมา"
        }
      },
      "week-narrow": {
        "-1": "สัปดาห์ที่แล้ว",
        "0": "สัปดาห์นี้",
        "1": "สัปดาห์หน้า",
        "future": {
          "other": "ใน {0} สัปดาห์"
        },
        "past": {
          "other": "{0} สัปดาห์ที่แล้ว"
        }
      },
      "week-short": {
        "-1": "สัปดาห์ที่แล้ว",
        "0": "สัปดาห์นี้",
        "1": "สัปดาห์หน้า",
        "future": {
          "other": "ใน {0} สัปดาห์"
        },
        "past": {
          "other": "{0} สัปดาห์ที่แล้ว"
        }
      },
      "year": {
        "-1": "ปีที่แล้ว",
        "0": "ปีนี้",
        "1": "ปีหน้า",
        "future": {
          "other": "ในอีก {0} ปี"
        },
        "past": {
          "other": "{0} ปีที่แล้ว"
        }
      },
      "year-narrow": {
        "-1": "ปีที่แล้ว",
        "0": "ปีนี้",
        "1": "ปีหน้า",
        "future": {
          "other": "ใน {0} ปี"
        },
        "past": {
          "other": "{0} ปีที่แล้ว"
        }
      },
      "year-short": {
        "-1": "ปีที่แล้ว",
        "0": "ปีนี้",
        "1": "ปีหน้า",
        "future": {
          "other": "ใน {0} ปี"
        },
        "past": {
          "other": "{0} ปีที่แล้ว"
        }
      }
    },
    "locale": "th"
  });
}